import { io } from "socket.io-client";
import { api } from "../api";

let socket = null;

function getSocketBaseUrl() {
  const apiBase = api?.defaults?.baseURL;
  if (apiBase) {
    return String(apiBase).replace(/\/api\/?$/, "");
  }

  const apiUrl =
    process.env.REACT_APP_API_URL_PRD ||
    process.env.REACT_APP_API_URL_DSV ||
    "http://localhost:4000/api";

  return apiUrl.replace(/\/api\/?$/, "");
}

export function getSocket() {
  if (!socket) {
    socket = io(getSocketBaseUrl(), {
      transports: ["websocket", "polling"],
      autoConnect: true,
    });

    socket.on("connect", () => {
      // eslint-disable-next-line no-console
      console.log("[socket] connected", socket.id);
    });

    socket.on("connect_error", (err) => {
      // eslint-disable-next-line no-console
      console.error("[socket] connect_error", err?.message);
    });
  }

  return socket;
}

export function onDataChanged(handler) {
  const client = getSocket();
  client.on("data:changed", handler);
  client.on("connect", handler);

  return () => {
    client.off("data:changed", handler);
    client.off("connect", handler);
  };
}
